import axiosClient from "./../api/axios.config";

export const service = {
    cargarCfdiConAddenda,
    getDetalleRecepcion,
    agregarEditarAddenda,
    getListadoCfdisRecibidos,
    getSucursales
};

async function getSucursales(payload) {
    try {
        const response = await axiosClient({
            method: "get",
            // url: "recepcionador_backend/v1/sucursal/list",
            url: "recepcionador_backend/v1/sucursal",
            params: payload,
        });
        if (response.status == 200) {
            return {
                success: true, 
                data: response.data.data
            };
        } else {
            return {
                success: false, 
                data: response.error
            };
        }
    } catch (error) {
        return {
            success: false, 
            data: error.response
        };
    }
}

async function getListadoCfdisRecibidos(payload) {
    try {
        const response = await axiosClient({
            method: "get",
            url: "recepcionador_backend/v1/cfdi",
            params: payload,
        });
        if (response.status == 200) {
            return {
                success: true, 
                data: response.data.data
            };
        } else {
            return {
                success: false, 
                data: response.error
            };
        }
    } catch (error) {
        return {
            success: false, 
            data: error.response
        };
    }
}

async function getDetalleRecepcion(payload) {
    try {
        const response = await axiosClient({
            method: "get",
            url: "recepcionador_backend/v1/recepcion-item",
            params: payload,
        });
        if (response.status == 200) {
            return {
                success: true, 
                data: response.data.data
            };
        } else {
            return {
                success: false, 
                data: response.error
            };
        }
    } catch (error) {
        return {
            success: false, 
            data: error.response
        };
    }
}

async function cargarCfdiConAddenda(payload) {
    try {
        const response = await axiosClient({
            method: "post",
            url: "recepcionador_backend/v1/recepcion",
            data: payload,
        });
        if (response.data.status == "success") {
            return {
                success: true, 
                data: response.data.data
            };
        } else {
            return {
                success: false, 
                data: response.error
            };
        }
    } catch (error) {
        console.log('service cargarCfdiConAddenda catch');
        console.log(error.response);
        return {
            success: false, 
            data: error.response
        };
    }
}

async function agregarEditarAddenda(payload) {
    try {
        const response = await axiosClient({
            method: "post",
            url: "recepcionador_backend/v1/addenda",
            data: payload,
        });

        if (response.data.status == "success") {
            return {
                success: true, 
                data: response.data.data
            };
        } else {

            return {
                success: false, 
                data: response.message
            };
        }
    } catch (error) {
        
        let errorMensaje = "";

        if (error.response && error.response.data) {
            errorMensaje = 'Código ' + error.response.data.code + ': ' + error.response.data.message;
        }
        return {
            success: false, 
            data: errorMensaje
        };
    }
}